module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/card-games-icon-9ce0f58347fc95e410f3aa7fe3a77f5a.png";